"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _icon = _interopRequireDefault(require("../../icon"));

var _utils = require("../../utils");

var _headCell = require("../head-cell");

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var _ref = /*#__PURE__*/_jsx(_icon["default"], {
  name: "chevron-reverse",
  color: "#0073f7"
});

var _ref2 = /*#__PURE__*/_jsx(_icon["default"], {
  name: "chevron",
  color: "#0073f7"
});

var HorizontalScroll = /*#__PURE__*/function (_PureComponent) {
  _inherits(HorizontalScroll, _PureComponent);

  var _super = _createSuper(HorizontalScroll);

  function HorizontalScroll() {
    var _this;

    _classCallCheck(this, HorizontalScroll);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isHaveScroll: false,
      scrollLeftEnd: false,
      scrollRightEnd: false,
      wrapperLeft: 0
    });

    _defineProperty(_assertThisInitialized(_this), "attachedScrollHandler", false);

    _defineProperty(_assertThisInitialized(_this), "wrapperScrollHandler", function (e) {
      _this.setButtonVisibility(e.currentTarget);
    });

    _defineProperty(_assertThisInitialized(_this), "setButtonVisibility", function (wrapperEl) {
      var scrollLeftMax = wrapperEl.scrollWidth - wrapperEl.clientWidth;
      var inRightEnd = wrapperEl.scrollLeft === scrollLeftMax;
      return _this.setState({
        scrollLeftEnd: wrapperEl.scrollLeft === 0,
        scrollRightEnd: inRightEnd
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollVisibility", function () {
      var wrapperEl = _this.props.scrollWrapperRef.current;

      if (!wrapperEl) {
        return;
      }

      var isHaveScroll = wrapperEl.scrollWidth !== wrapperEl.clientWidth;

      _this.setState({
        isHaveScroll: isHaveScroll
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setWrapperLeftPosition", function () {
      var stickyColsWidth = _this.getStickyColsWidth();

      _this.setState({
        wrapperLeft: stickyColsWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getHeadElements", function () {
      var headRef = _this.props.headRef;
      var headEl = headRef.current;

      if (!headEl) {
        return [];
      }

      return _toConsumableArray(headEl.children);
    });

    _defineProperty(_assertThisInitialized(_this), "getStickyColsWidth", function () {
      var headChildren = _this.getHeadElements();

      var stickyCols = headChildren.filter(function (node) {
        return node.className.includes(_headCell.STICKY_CLASS);
      });
      return stickyCols.reduce(function (accum, current) {
        return accum += current.clientWidth;
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "getHeadCol", function (type) {
      var scrollWrapperRef = _this.props.scrollWrapperRef;
      var wrapperEl = scrollWrapperRef.current;

      if (!wrapperEl) {
        return null;
      }

      var headChildes = _this.getHeadElements();

      var stickyColsWidth = _this.getStickyColsWidth();

      if (type === 'first') {
        var wrapperScrollWidth = wrapperEl.scrollLeft + stickyColsWidth;
        return headChildes.filter(function (node) {
          return node.offsetLeft < wrapperScrollWidth;
        }).pop() || null;
      }

      if (type === 'last') {
        var wrapperOffset = wrapperEl.clientWidth + wrapperEl.scrollLeft;
        return headChildes.find(function (node) {
          return node.offsetLeft + node.clientWidth > wrapperOffset;
        }) || null;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (type) {
      var scrollWrapperRef = _this.props.scrollWrapperRef;
      var wrapperEl = scrollWrapperRef.current;

      var firstHiddenNode = _this.getHeadCol(type);

      if (!wrapperEl || !firstHiddenNode) {
        return;
      }

      var stickyColsWidth = _this.getStickyColsWidth();

      if (type === 'first') {
        wrapperEl.scrollLeft = firstHiddenNode.offsetLeft - stickyColsWidth;

        var nextCol = _this.getHeadCol(type);

        if (!nextCol) {
          _this.setState({
            scrollLeftEnd: true
          });
        }
      }

      if (type === 'last') {
        wrapperEl.scrollLeft = firstHiddenNode.offsetLeft + firstHiddenNode.clientWidth - wrapperEl.clientWidth;

        var _nextCol = _this.getHeadCol(type);

        if (!_nextCol) {
          _this.setState({
            scrollRightEnd: true
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      var scrollWrapperEl = _this.props.scrollWrapperRef.current;

      if (scrollWrapperEl) {
        _this.setButtonVisibility(scrollWrapperEl);
      }
    });

    return _this;
  }

  _createClass(HorizontalScroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var wrapperEl = this.props.scrollWrapperRef.current;

      if (!wrapperEl) {
        return;
      }

      (0, _utils.onNextFrame)(this.setScrollVisibility);
      this.setButtonVisibility(wrapperEl);

      if (!this.attachedScrollHandler) {
        this.attachedScrollHandler = true; // $FlowFixMe - invalid first argument

        wrapperEl.addEventListener('scroll', this.wrapperScrollHandler);
      }

      this.setWrapperLeftPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var wrapperEl = this.props.scrollWrapperRef.current;

      if (wrapperEl) {
        this.attachedScrollHandler = false; // $FlowFixMe - invalid first argument

        wrapperEl.removeEventListener('scroll', this.wrapperScrollHandler);
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          isHaveScroll = _this$state.isHaveScroll,
          scrollLeftEnd = _this$state.scrollLeftEnd,
          scrollRightEnd = _this$state.scrollRightEnd;

      if (!isHaveScroll) {
        return null;
      }

      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-table-horizontal-scroll'),
        style: {
          top: this.props.headHeight,
          left: this.state.wrapperLeft
        }
      }, void 0, !scrollLeftEnd && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-table-horizontal-scroll__button', 'xsui-table-horizontal-scroll__button--left'),
        onClick: function onClick() {
          return _this2.scrollTo('first');
        }
      }, void 0, _ref), !scrollRightEnd && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-table-horizontal-scroll__button', 'xsui-table-horizontal-scroll__button--right'),
        onClick: function onClick() {
          return _this2.scrollTo('last');
        }
      }, void 0, _ref2));
    }
  }]);

  return HorizontalScroll;
}(_react.PureComponent);

_defineProperty(HorizontalScroll, "defaultProps", {
  headHeight: 0,
  headRef: /*#__PURE__*/(0, _react.createRef)(),
  scrollWrapperRef: /*#__PURE__*/(0, _react.createRef)()
});

var _default = HorizontalScroll;
exports["default"] = _default;